import actions from './actions';

// This is a link to an action defined in actions.js.
const {  } = actions;

export default {
};
